import { getApiGalaxyServer } from 'services';

export interface GalaxyService {
  id: number;
  name: string;
  serviceName: string;
  cloudIntegrationName?: string;
  onPremIntegrationName?: string;
  serviceDisplayName: string;
  onPremIntegrationDisplayName?: string;
  isIntegrationAgent: boolean;
  requiredForSubscription?: boolean;
  requiredForSandbox?: boolean;
  canBeSeeded?: boolean;
  mustBeSeeded?: boolean;
  seedBucket?: string | null;
  sourceSeedBucket?: string | null;
  isArchived: boolean;
}

/**
 * GET /service
 * Returns every non-archived service registered in galaxy-server.
 */
export const getServicesApi = ({ token, config = {} }: BaseApiParams<void>) => {
  return getApiGalaxyServer<GalaxyService[]>(`/service`, config, token);
};
